import { StudentRegistrationType } from "./Enums";

const DataProvider = {
  termsandconditon: [
    {
      text: "Coordinators must be at least 18 years old.",
    },
    {
      text: "Coordinators must have completed at least the 12th standard.",
    },
    {
      text: "PRADNYA LEARN AND ACHIEVE EDUTECH will provide free online training, which all coordinators must attend as scheduled.",
    },
    {
      text: "Coordinators are representatives on a incentives basis only and are not employees of PRADNYA LEARN AND ACHIEVE EDUTECH. No benefits will be provided beyond the prescribed incentives.",
    },
    {
      text: "Coordinators will earn a 12.5% incentives on their total sales, with the potential for additional special incentives as announced by PRADNYA LEARN AND ACHIEVE EDUTECH.",
    },
    {
      text: "Coordinators have three products to sell: Bharat SAT examination registration, Mock test packages, and the Pradnya Study n Learn Mobile App.",
    },
    {
      text: "Coordinators must link their bank accounts to the PRADNYA LEARN AND ACHIEVE EDUTECH payment system to receive payments.",
    },
    {
      text: "Coordinators can withdraw their incentives once a week, with a minimum withdrawal amount of Rs. 1000 (one thousand rupees only).",
    },
    {
      text: "Withdrawals will be processed via NEFT to the coordinator's bank account after verification by PRADNYA LEARN AND ACHIEVE EDUTECH’s accounting staff.",
    },
    {
      text: "Coordinators must provide accurate and truthful information when filling out the form to join as a coordinator.",
    },
    {
      text: "Coordinators must adhere to the standard ethics and practices of the sales team, as provided in the training sessions.",
    },
    {
      text: "Coordinators must promote all PRADNYA LEARN AND ACHIEVE EDUTECH products honestly and maintain the company's image.",
    },
    {
      text: "Coordinators are responsible for ensuring their contact information is kept up-to-date.",
    },
    {
      text: "Coordinators must comply with all applicable laws and regulations in their sales activities.",
    },
    {
      text: "Coordinators must promptly report any issues or disputes to PRADNYA LEARN AND ACHIEVE EDUTECH for resolution.",
    },
    {
      text: "PRADNYA LEARN AND ACHIEVE EDUTECH reserves the right to modify these terms and conditions at any time, with notice provided to coordinators.",
    },
    {
      text: "Coordinators agree not to engage in any activity that could harm the reputation or interests of PRADNYA LEARN AND ACHIEVE EDUTECH.",
    },
    {
      text: "Failure to comply with these terms and conditions may result in termination of the coordinator's status and forfeiture of any pending incentivess.",
    },
  ],
  bharatSatBenefits: [
    {
      text: "Skill Enhancement: Participating in Bharat SAT encourages students to develop a broad spectrum of skills, from problem-solving to time management, fostering their holistic growth.",
    },
    {
      text: "Healthy Competition: Healthy competition is the cornerstone of personal development. Bharat SAT instills a sense of competitiveness in students, motivating them to strive for excellence.",
    },
    {
      text: "Scholarships: With monthly scholarships awarded to the top performers at various levels, Bharat SAT eases the financial burden on families, making quality education more accessible.",
    },
    {
      text: "Identify Potential: Bharat SAT's diagnostic aspect helps students and educators identify their strengths and weaknesses, enabling them to tailor their educational paths for optimal growth.",
    },
    {
      text: "National Recognition: Achieving success in Bharat SAT is a badge of honor, signifying excellence at a national level, which can open doors to a world of opportunities.",
    },
  ],

  mediumList: [
    { value: "English", label: "English" },
    // { value: "Hindi", label: "Hindi" },
    { value: "Marathi", label: "Marathi" },
    { value: "Semi English", label: "Semi English" },
  ],
  Genders: [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Other", label: "Other" },
  ],
  Qualification: [
    { value: "Post Graduation", label: "Post Graduation" },
    { value: "Bachelor's", label: "Bachelor's" },
    { value: "12th Standard", label: "12th Standard" },
  ],
  RegisterBy: [
    { value: StudentRegistrationType.student, label: "Student/Self" },
    { value: StudentRegistrationType.coordinator, label: "Coordinator" },
  ],
  accountType: [
    { value: "Saving", label: "Saving" },
    { value: "Current", label: "Current" },
    { value: "Salary", label: "Salary" },
  ],
};

export default DataProvider;
